<template>
  <div class="footer-nav toolbar tabbar">
    <div class="toolbar-inner">
      <a
        class="tab--link external"
        :class="{ active: isHomePageActive == true }"
				@click="goPage('/', 'HP')"
      >
        <i class="icon demo-icon-1"></i>
        <span>首页</span>
      </a>
      <a
        class="tab--link external bottom--cruiseSearch"
        :class="{ active: isCruiseSearchActive == true }"
				@click="goPage('/Rccl.Cruise/CruiseSearch/Search', 'homePort')"
      >
        <i class="icon demo-icon-2"></i>
        <span>中国出发航线</span>
      </a>
      <a
        class="tab--link external bottom--shoppingCart"
        :class="{ active: isShoppingCartActive == true }"
				@click="goPage(shoppingCartLink, 'cart')"
      >
        <div class="shoppingCartCount" v-if="shoppingCartCount > 0">
          <span id="shoppingCartCount">{{ shoppingCartCount }}</span>
        </div>
        <i class="icon demo-icon-4"></i>
        <span>购物车</span>
      </a>
      <!-- @click="goPage(rowUrl + '/Cruise/MobileSearch', 'rowPort', true)" -->
      <a
        class="tab--link external bottom--cruiseSearch"
        :class="{ active: isRowActive == true }"
				@click="goPage('/Rccl.Cruise/CruiseSearch/SearchRow', 'homePort')"
      >
        <i class="icon demo-icon-3"></i>
        <span>海外出发航线</span>
      </a>

      <a
        class="tab--link external bottom--userCenter"
        :class="{ active: isUserCenterActive == true }"
				@click="goPage('/Rccl.UserCenter/CustomerInfo/Info', 'personalCenter')"
      >
        <i class="icon demo-icon-5"></i>
        <span>个人中心</span>
      </a>
    </div>
  </div>
</template>

<script>
import { gioTracking } from "@/utilities/tools";
export default {
  name: "BaseFooter",
  data() {
    return {
      shoppingCartLink: {
        name: "ShoppingCart",
        query: {},
      },
      hide: false,
      isHomePageActive: false,
      isCruiseSearchActive: false,
      isShoppingCartActive: false,
      isUserCenterActive: false,
      isRowActive: false,
    };
  },
  beforeMount() {
    this.setShoppingCartLink(this.$router.currentRoute);
    this.checkTabActive(this.$router.currentRoute.path);
  },
  methods: {
    setShoppingCartLink(router) {
      let query = {};
      if (router.name === "CruiseDetail") {
        query = router.query;
      }
      this.shoppingCartLink = {
        name: "ShoppingCart",
        query: query,
      };
    },
    checkTabActive(path) {
      path = path.toLowerCase();
      console.log(path,'pathpathpath')

      this.isHomePageActive = false;
      this.isCruiseSearchActive = false;
      this.isShoppingCartActive = false;
      this.isUserCenterActive = false;
      this.isRowActive = false;
      if (path == "/") {
        this.isHomePageActive = true;
      } else if (path == "/rccl.cruise/cruisesearch/search") {
        this.isCruiseSearchActive = true;
      } else if (path == "/rccl.booking/booking/shoppingcart") {
        this.isShoppingCartActive = true;
      } else if (path == "/rccl.usercenter/customerinfo/info") {
        this.isUserCenterActive = true;
      } else if (path == "/rccl.cruise/cruisesearch/searchrow") {
        this.isRowActive = true;
      }
    },
		goPage(link, eventName, isOpenNew) {
			gioTracking('track','evt_ButtonClicked', {'btnType': eventName});
			if (isOpenNew) {
				location.href = link;
			} else {
				this.$router.push(link);
			}
		}
  },
  computed: {
    shoppingCartCount() {
      return this.$store.state.booking.shoppingCartCount;
    },
    rowUrl() {
      return process.env.VUE_APP_TUI_URL;
    },
  },
  watch: {
    $route(to) {
      this.checkTabActive(to.path);
    },
  },
};
</script>

<style lang="less" scoped>
.footer-nav .shoppingCartCount {
  display: block;
}
</style>
